import {ACTIVITIES} from "@/store/auth/auth";
import {mapGetters} from "vuex";
import httpClient from "@/http";
import api from "@/api";

export const ArchiveMixin = {
    computed: {
        ...mapGetters(['ability', 'isSuperuser', 'isInController', 'userOrganizationActivities', 'isMunicipalController']),
    },
    data() {
        return {
            archiveControlsVisible: false,
            archiveControlType: 0,
        }
    },
    methods: {
        getTableRef() {},
        getArchiveUrl() {},
        getExtractUrl() {},
        getDeleteUrl() {},
        canWorkWithArchive() {
            return this.isSuperuser || !this.isSuperuser && this.isInController
                && this.userOrganizationActivities.includes(ACTIVITIES.CONTROL) && !this.isMunicipalController;
        },
        getArchiveDateFilter() {
            return { title: 'Дата архивации', name: 'archive_date', type: 'dateFromTo' }
        },
        onArchiveDateFilterAdded(name, value, label) {
            const ref = this.getTableRef();
            if (!ref || ref && !ref.hasOwnProperty('onFilterAdded')) { return }
            ref.onFilterAdded(name, value, label)
        },
        onArchiveDateFilterRemoved(name, value, label, parentFilterName) {
            const ref = this.getTableRef();
            if (!ref || ref && !ref.hasOwnProperty('onFilterRemoved')) { return }
            ref.onFilterRemoved(name, value, label, parentFilterName)
        },
        getSelectedRowIds() {
            const ref = this.getTableRef();
            if (!ref || ref && !ref.hasOwnProperty('getSelectedRowIds')) { return 0 }
            return ref.getSelectedRowIds();
        },
        getSelectedLabel() {
            const len = this.getSelectedRowIds().length;
            const rem = len % 10;
            if (rem === 1 && (len < 10 || len > 20)) {
                return 'Выбрана ' + len + ' запись'
            }
            else if (rem > 1 && rem < 5  && (len < 10 || len > 20)) {
                return 'Выбрано ' + len + ' записи'
            } else {
                return 'Выбрано ' + len + ' записей'
            }
        },
        onArchiveControlTypeChanged() {
            const ref = this.getTableRef();
            if (!ref) { return }
            ref.onFilterRemoved('needs_archive')
            ref.onFilterRemoved('is_archived')
            ref.onFilterRemoved('is_actual')
            if (parseInt(this.archiveControlType) === 1) {
                ref.onFilterAdded('needs_archive', true, 'Создано более 3 лет назад', null, null)
            }
            if (parseInt(this.archiveControlType) === 2) {
                ref.onFilterAdded('is_archived', true, 'В архиве', null, null)
            }
            if (parseInt(this.archiveControlType) === 3) {
                ref.onFilterAdded('is_actual', true, 'Актуальные', null, null)
            }
        },
        onFilterReset(name, value) {
            if (name === 'archive_date_from' || name === 'archive_date_to') {
                this.$refs.archiveDate.resetChildValue(value, name)
            } else {
                const ref = this.getTableRef();
                if (!ref) { return }
                if (!name || name && (name === 'needs_archive' || name === 'is_archived')) {
                    this.archiveControlType = 0;
                    ref.onFilterRemoved('archive_date_from')
                    ref.onFilterRemoved('archive_date_to')
                }
            }

        },
        onMoveToArchiveClick() {
            const vm = this;
            const ref = this.getTableRef();
            httpClient.post(vm.getArchiveUrl(), { ids: vm.getSelectedRowIds() })
            .then((response) => {
                if (ref) {
                    ref.resetPage()
                }
            }).catch((reason) => {
                vm.$bvToast.toast(reason, { title: 'Не удалось переместить записи в архив', variant: 'danger'})
            })
        },
        onReturnFromArchiveClick() {
            const vm = this;
            const ref = this.getTableRef();
            httpClient.post(vm.getExtractUrl(), { ids: vm.getSelectedRowIds() })
            .then((response) => {
                if (ref) {
                    ref.resetPage()
                }
            }).catch((reason) => {
                vm.$bvToast.toast(reason, { title: 'Не удалось вернуть записи из архива', variant: 'danger'})
            })
        },
        showIrreversibleDeleteModal() {
            this.$refs.deleteIrreversibly.setRows(this.getSelectedRowIds())
            this.$bvModal.show('delete-irreversibly');
        },
        getIrreversibleDeleteUrl() {
            return this.getDeleteUrl()
        },
        onIrreversibleDeleteSuccess() {
            const ref = this.getTableRef();
            if (ref) {
                ref.resetPage()
            }
        }
    }
}